exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-field.amount[data-v-52538da6]{position:relative}.form-field.amount input[data-v-52538da6]{padding-left:25px}.form-field.amount .amount-icon[data-v-52538da6]{position:absolute;bottom:9px;left:10px;font-size:19px;color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52538da6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/applicants/ApplicantConvertToResident.vue
// module id = C4uc
// module chunks = 0 1